import { controlIcons } from '../../../constants/assets'
import {
  availabilityOptions,
  categoryOptions,
  languageOptions,
  type DriverFilters,
} from '../../../data/driverFilters'
import { FilterField } from '../../../components/ui/FilterField'
import { SearchInput } from '../../../components/ui/SearchInput'
import { Select } from '../../../components/ui/Select'

/** Controls on this page are 59px tall and drop their panel 21px below the trigger. */
const FIELD_HEIGHT = 59
const PANEL_GAP = 21

type DriversFilterBarProps = {
  filters: DriverFilters
  onChange: (filters: DriverFilters) => void
  onAddDriver: () => void
}

export const DriversFilterBar = ({ filters, onChange, onAddDriver }: DriversFilterBarProps) => (
  <div className="flex flex-wrap items-end gap-[12px]">
    <FilterField className="min-w-[240px] flex-[1_1_300px]" label="Search">
      <SearchInput
        height={FIELD_HEIGHT}
        label="Search by driver name"
        onChange={(query) => onChange({ ...filters, query })}
        placeholder="Search by driver name..."
        value={filters.query}
      />
    </FilterField>

    <FilterField className="min-w-[190px] flex-[1_1_190px]" label="Availability">
      <Select
        height={FIELD_HEIGHT}
        label="Availability"
        onChange={(availability) => onChange({ ...filters, availability })}
        options={availabilityOptions}
        panelGap={PANEL_GAP}
        value={filters.availability}
      />
    </FilterField>

    <FilterField className="min-w-[190px] flex-[1_1_190px]" label="Vehicle Categories">
      <Select
        height={FIELD_HEIGHT}
        label="Vehicle Categories"
        onChange={(category) => onChange({ ...filters, category })}
        options={categoryOptions}
        panelGap={PANEL_GAP}
        value={filters.category}
      />
    </FilterField>

    <FilterField className="min-w-[190px] flex-[1_1_190px]" label="Languages">
      <Select
        height={FIELD_HEIGHT}
        label="Languages"
        onChange={(language) => onChange({ ...filters, language })}
        options={languageOptions}
        panelGap={PANEL_GAP}
        value={filters.language}
      />
    </FilterField>

    <button
      type="button"
      onClick={onAddDriver}
      className="flex h-[59px] w-[190px] shrink-0 items-center justify-center gap-[6px] rounded-[12px] bg-dash-primary px-[18px]"
    >
      <img alt="" aria-hidden className="block size-[24px] max-w-none" src={controlIcons.add} />
      <span className="whitespace-nowrap font-host text-[16px] font-medium leading-normal text-white">
        Add Driver
      </span>
    </button>
  </div>
)
